import React, { FC, MouseEvent, useState } from "react";

import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
	Box,
	Divider,
	IconButton,
	ListItemIcon,
	ListItemText,
	Menu,
	MenuItem,
	Typography,
} from "@mui/material";

import { Translate } from "@/components/Application/Translate";

type Props = {
	sortOrder: "ASC" | "DESC";
	setSortOrder: (order: "ASC" | "DESC") => void;
};

const SortMenu: FC<Props> = ({ sortOrder, setSortOrder }) => {
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
	const open = Boolean(anchorEl);

	const handleClick = (event: MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleMenuItemClick = (order: "ASC" | "DESC") => {
		setSortOrder(order);
		handleClose();
	};

	return (
		<Box display="inline-flex" justifySelf="end">
			<IconButton
				aria-label="Sort menu"
				aria-controls="sort-menu"
				aria-haspopup="true"
				onClick={handleClick}
			>
				<FilterListIcon />
			</IconButton>

			<Menu
				id="sort-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				keepMounted
				PaperProps={{
					elevation: 3,
					sx: {
						borderRadius: 2,
						minWidth: 250,
						paddingY: 1,
					},
				}}
			>
				<Typography
					variant="overline"
					sx={{ paddingX: 2, paddingY: 0.5, color: "text.secondary" }}
				>
					<Translate String="Common.Filters.Heading">SORT BY</Translate>
				</Typography>

				<MenuItem
					selected={sortOrder === "ASC"}
					onClick={() => handleMenuItemClick("ASC")}
				>
					<ListItemIcon>
						<ArrowUpwardIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText
						primary={
							<Translate String="Common.Filters.ASC">
								Oldest to Newest
							</Translate>
						}
						secondary={
							<Translate String="Common.Filters.ASC.Description">
								Show oldest items first
							</Translate>
						}
					/>
				</MenuItem>

				<MenuItem
					selected={sortOrder === "DESC"}
					onClick={() => handleMenuItemClick("DESC")}
				>
					<ListItemIcon>
						<ArrowDownwardIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText
						primary={
							<Translate String="Common.Filters.DESC">
								Newest to Oldest
							</Translate>
						}
						secondary={
							<Translate String="Common.Filters.DESC.Description">
								Show most recent items first
							</Translate>
						}
					/>
				</MenuItem>
			</Menu>
		</Box>
	);
};

export default SortMenu;
